// External library imports
import styled from 'styled-components';
import { Grid } from '@interstate/components/Grid';

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const RightAlignedGrid = styled(Grid)`
    display: flex;
    justify-content: flex-end;
    padding-right: 8px;
`;

export const GridRowContainer = styled(Grid)<{ mt?: number }>`
    && {
        width: 100%;
        margin: 0;
        padding: 0;
        margin-top: ${({ mt }) => `${mt}rem`};
    }
`;
